import React, { useState, useEffect } from "react";
import "../udi/outStockConfig.less";
import "@/static/style/margin.less";
import "@/static/style/init.less";
import "@/static/style/common.less";
import {
  Button,
  Table,
  message,
  Input,
  Upload,
  Pagination,
  Spin,
  Form,
} from "antd";
import _, { get } from "lodash";
import { getCookie, tokenConfig } from "@/public/utils";
import moment from "moment";
import {
  operatorData,
  querySupplierItemListApi,
  downloadProductRelationApi,
  downloadRelationTemplateApi,
  uploadProductRelationUrl,
} from "./service";

const columns = [
  {
    title: "视客商品编码",
    key: "item_code",
    dataIndex: "item_code",
    align: "center",
  },
  {
    title: "视客商品名称",
    key: "item_name",
    dataIndex: "item_name",
    align: "center",
  },
  {
    title: "视客商品类别",
    key: "category_name",
    dataIndex: "category_name",
    align: "center",
  },
  {
    title: "品牌",
    key: "brand_name",
    dataIndex: "brand_name",
    align: "center",
  },
  {
    title: "货品编码关系对照",
    key: "adjustNo",
    dataIndex: "adjustNo",
    align: "center",
    render: (text, record) => {
      return (
        <span>
          <a onClick={() => toDetailPage(record)}>查看</a>
        </span>
      );
    },
  },
];

const toDetailPage = (record) => {
  const url =
    `${"/main/supplierGood/detail"}${"?item_code="}` + get(record, "item_code");
  window.open(url);
};

const List = (props) => {
  const [searchForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({
    ...operatorData,
    supplier_code: getCookie("supplier_code") || "",
    item_code_name: "",
    product_code_name: "",
    no: 1,
    size: 10,
  });
  const [data, setData] = useState([]);

  // 表单字段 -> 接口字段映射（接口要求 sigo_name / supplier_product_code / page_index / page_size）
  const buildQueryParams = (src) => {
    return {
      ...src,
      sigo_name: src.item_code_name || "",
      supplier_product_code: src.product_code_name || "",
      page_index: src.no || 1,
      page_size: src.size || 10,
    };
  };

  const getTableData = async (paramArg) => {
    const cur = paramArg || params;
    changeLoading(true);
    try {
      const res = await querySupplierItemListApi(buildQueryParams(cur));
      setParams({ ...cur, total: get(res, "data.data.count", 0) });
      setData(get(res, "data.data.data", []));
    } catch (err) {
      // ignore
    } finally {
      changeLoading(false);
    }
  };

  const changeLoading = (loading) => {
    setLoading(loading);
  };

  useEffect(() => {
    getTableData();
  }, []);

  const search = () => {
    const fields = searchForm.getFieldsValue();
    const next = {
      ...params,
      ...fields,
      no: 1,
    };
    setParams(next);
    getTableData(next);
  };

  const reset = () => {
    searchForm.resetFields();
    const next = {
      ...params,
      item_code_name: "",
      product_code_name: "",
      no: 1,
    };
    setParams(next);
    getTableData(next);
  };

  const exportExcel = () => {
    downloadProductRelationApi(params);
  };

  const downloadTemplate = () => {
    downloadRelationTemplateApi();
  };

  // 页数据修改
  const onShowSizeChange = (current, pageSize) => {
    try {
      const next = { ...params, size: pageSize, no: current };
      setParams(next);
      getTableData(next);
    } catch (error) {
      console.log(error);
    }
  };

  const personProps = {
    name: "file",
    action: uploadProductRelationUrl,
    headers: { ...tokenConfig },
    data: (file) => {
      return {
        supplier_code: getCookie("supplier_code") || "",
        operator_id: getCookie("accountId") || "",
        operator_name: getCookie("supplier_company_name") || "",
      };
    },
    accept:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
    beforeUpload: (file) => {
      if (
        ![
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
        ].includes(file.type)
      ) {
        message.error("请上传excel文件！");
      }
      return [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ].includes(file.type)
        ? true
        : Upload.LIST_IGNORE;
    },
    onChange: (info) => {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        var resp = get(info, "file.response") || {};
        if (resp.message) {
          message.success(resp.message);
        } else {
          message.success(`${info.file.name}导入成功`);
        }
        // 导入成功后重新查询列表，不刷新浏览器
        getTableData({ ...params, no: 1 });
      } else if (info.file.status === "error") {
        message.error(`${info.file.name}导入失败`);
      }
    },
  };

  return (
    <div className="purchaseAdjustList outStockConfig">
      <section
        className="search mb20"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* <h3>供货商品目录</h3> */}
        <Form
          form={searchForm}
          layout="inline"
          initialValues={{ item_code_name: "", product_code_name: "" }}
        >
          <Form.Item name="item_code_name" label="视客商品/货品：">
            <Input placeholder="请输入编码或名称" className="width_200_input" />
          </Form.Item>
        </Form>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Button type="primary" className="mr16" onClick={search}>
            查询
          </Button>
          <Button className="mr16" onClick={reset}>
            重置
          </Button>
          <Button type="primary" onClick={exportExcel}>
            导出
          </Button>
          <span className={"noProgressUplaod"}>
            <Upload {...personProps}>
              <Button className={"ml16"}>Excel导入</Button>
            </Upload>
          </span>
          <a className="ml16" onClick={downloadTemplate}>
            下载模板
          </a>
        </div>
      </section>
      <Spin spinning={loading}>
        <div style={{ overflow: "hidden" }} className="tableBody">
          <Table columns={columns} dataSource={data} pagination={false}></Table>
          <div style={{ float: "right" }} className="mt20">
            <Pagination
              current={get(params, "no")}
              showQuickJumper
              total={get(params, "total")}
              pageSize={get(params, "size")}
              showSizeChanger
              showTotal={() => {
                return (
                  <span style={{ marginRight: "20px", float: "left" }}>
                    共{get(params, "total")}条，每页{get(params, "size")}条
                  </span>
                );
              }}
              onShowSizeChange={onShowSizeChange}
              onChange={onShowSizeChange}
            />
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default List;



// WEBPACK FOOTER //
// ./src/pages/supplierGood/list.js